import { ref } from "vue";
import { api } from "@/services/api";

// Module-level singletons — shared across every component that imports this.
const unreadCount = ref(0);
const checked     = ref(false);
let   inFlight    = null;

export function useNotifications() {

  // Fetch the unread count. De-duplicates concurrent calls.
  async function fetchUnread() {
    if (!localStorage.getItem("token")) {
      unreadCount.value = 0;
      checked.value = true;
      return 0;
    }
    if (inFlight) return inFlight;

    inFlight = (async () => {
      try {
        const res = await api.get("/notifications/unread-count");
        // Be tolerant of the response shape: {count} | {unread} | {unread_count} | number
        const d = res?.data;
        const n =
          typeof d === "number" ? d :
          d?.count ?? d?.unread ?? d?.unread_count ?? 0;
        unreadCount.value = Number(n) || 0;
        checked.value = true;
        return unreadCount.value;
      } catch {
        // Stay silent — a failed badge fetch shouldn't surface an error
        return unreadCount.value;
      } finally {
        inFlight = null;
      }
    })();

    return inFlight;
  }

  // Optimistically zero the badge (e.g. after the user opens notifications)
  function clearUnread() {
    unreadCount.value = 0;
  }

  // Force a re-fetch next time (e.g. after login/logout)
  function reset() {
    unreadCount.value = 0;
    checked.value = false;
  }

  return { unreadCount, checked, fetchUnread, clearUnread, reset };
}